'use client'

import { CardGrid } from '@/components/common/CardGrid'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { usePage } from '@/components/providers/PageProvider'

import styles from './Similiar.module.scss'

export const Similiar = () => {
  const { page } = usePage()
  const similar = page?.similar

  if (!similar) return <ErrorBlock />

  return (
    <section className={styles.container}>
      <CardGrid recs={similar} />
    </section>
  )
}
